import { takeLatest, put, call } from "redux-saga/effects";
import request from "../../components/Utils/httpHelper";
import { CORE_API } from "../../config";
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from "../../constants";

import {
  GET_COUNTRY_INDUSTRY_REPORTS_LIST,
  getCountryIndustryReportsListSuccess,
  getCountryIndustryReportsListFailure,
  DELETE_REPORT,
  CREATE_REPORT,
  getCountryIndustryReportsList,
} from "./action";
import { toast } from "react-toastify";

export function* fetchCountryIndustryReportsList(action) {
  const requestURL = `${CORE_API}/publication/`;

  try {
    const { publicationType, search = "", page = 0, size = 10 } = action.payload;

    const response = yield call(request, requestURL, {
      method: "GET",
      headers: HTTP_HEADERS,
      params: { publicationType, search, page, size },
    });
    yield put(
      getCountryIndustryReportsListSuccess({
        content: response.data.content,
        total: response.data.totalElements,
        page: response.data.number,
      })
    );
  } catch (err) {
    yield put(
      getCountryIndustryReportsListFailure({
        ...err.response,
        status: "FAILURE",
      })
    );
  }
}

export function* fetchCountryIndustryReportsListSaga() {
  yield takeLatest(
    GET_COUNTRY_INDUSTRY_REPORTS_LIST,
    fetchCountryIndustryReportsList
  );
}

function* deleteReportSaga(action) {
  try {
    const { id, publicationType } = action.payload;
    yield call(
      request,
      `${CORE_API}/publication/delete/${id}`,
      {
        method: "DELETE",
        headers: HTTP_HEADERS,
      }
    );

    toast.success("Report deleted successfully");

    yield put(getCountryIndustryReportsList({ publicationType, page: 0, size: 10 }));
  } catch (err) {
    toast.error("Delete failed");
  }
}



export function* watchDeleteReport() {
  yield takeLatest(DELETE_REPORT, deleteReportSaga);
}

export function* createReportSaga(action) {
  try {
    const formData = new FormData();

    formData.append("multipartFile", action.payload.file);
    formData.append("reportTitle", action.payload.reportTitle);
    formData.append("reportDate", action.payload.reportDate);
    formData.append("publicationType", action.payload.publicationType);
    formData.append("publicationName", action.payload.publicationName);


    yield call(request, `${CORE_API}/publication/add`, {
      method: "POST",
      headers: HTTP_HEADERS_FORMDATA,
      data: formData,
    });

    toast.success("Report created successfully");

    yield put(getCountryIndustryReportsList({
      publicationType: action.payload.publicationType,
      page: 0,
      size: 10,
    }));

  } catch (err) {
    toast.error(
      err?.response?.data?.message || "Failed to create report"
    );
  }
}

export function* watchCreateReport() {
  yield takeLatest(CREATE_REPORT, createReportSaga);
}

import { EDIT_REPORT } from "./action";

function* editReportSaga(action) {
  try {

    const formData = new FormData();
    formData.append("id", action.payload.id);
    formData.append("reportTitle", action.payload.reportTitle);
    formData.append("reportDate", action.payload.reportDate);
    formData.append("publicationName", action.payload.publicationName);
    formData.append("publicationType", action.payload.publicationType);
    formData.append("multipartFile", action.payload.file ? action.payload.file : new Blob());

    yield call(request, `${CORE_API}/publication/edit`, {
      method: "PUT",
      headers: HTTP_HEADERS_FORMDATA,
      data: formData,
    });

    toast.success("Report updated successfully");

    yield put(
      getCountryIndustryReportsList({
        publicationType: action.payload.publicationType,
        page: 0,
        size: 10,
      })
    );
  } catch (err) {
    toast.error(err?.response?.data?.message || "Update failed");
  }
}

export function* watchEditReport() {
  yield takeLatest(EDIT_REPORT, editReportSaga);
}


